import { lighten, styled, TableCell } from "@mui/material";

const LAYOUT_TOGGLE_STORAGE_KEY = "ENABLE_ALTERNATE_LAYOUT";
const useAlternateLayout = localStorage.getItem(LAYOUT_TOGGLE_STORAGE_KEY) === "true";
export const TableCellHighlighted = styled(TableCell)(({ theme }) => ({
  backgroundColor: useAlternateLayout
    ? `${lighten(theme.palette.secondary.main, 0.6)} !important`
    : `${theme.palette.primary.dark} !important`,
}));
